import _ from 'lodash'
import { mapActions } from 'vuex'
import SlideApi from '@/api/slide'
import { setObjectToIndexedDB, Stores, removeObjectFromIndexedDB } from '@/utils/indexedDB/indexed.db'
import Socket from '@/socket.js'

export default {
  methods: {
    ...mapActions(['updateSlideActiveAction', 'updateSlideByIdAction']),
    callUpdateSlideApi: _.debounce(async function debounceUpdateSlide(payload, slideId) {
      await SlideApi.updateSlideById(slideId || this.slideActive.id, {
        ...payload,
        uniqueAccessCode: this.presentation.uniqueAccessCode,
        socketId: Socket.getSocketId(),
      })
    }, 1000, { leading: true, trailing: true }),

    updateCanvasBlocks(newCanvasBlocks, slideId) {
      const payload = {
        id: slideId,
        type: 'freestyle',
        canvasBlocks: newCanvasBlocks,
      }
      // Update on local state
      this.updateSlideByIdAction(payload)
      // Update on IndexedDB
      setObjectToIndexedDB(slideId, Stores.contentSlideCanvasBlocksStore, {
        canvasBlocks: newCanvasBlocks,
      }, () => { // on error
        // if failed to set to IndexedDB -> remove the object in IndexedDB, to ensure that future access will get the latest data on DB
        removeObjectFromIndexedDB(slideId, Stores.contentSlideCanvasBlocksStore, () => {}, () => {})
        // Update on DB via calling slide/update API
        this.callUpdateSlideApi(payload, slideId)
      }, () => { // on success
        // Update on DB via calling slide/update API
        this.callUpdateSlideApi(payload, slideId)
      })
    },
  },
}
